import { storage } from '../utils/storage';

const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:3002';

class WebSocketService {
  constructor() {
    this.ws = null;
    this.listeners = {};
    this.restaurantId = null;
    this.sessionId = null;
    this.reconnectTimeout = null;
    this.shouldReconnect = true;
  }

  connect(restaurantId = null, sessionId = null) {
    // Si no se proporciona restaurantId, intentar obtenerlo del localStorage
    if (!restaurantId) {
      restaurantId = storage.get('restaurantId');
    }

    // Si no se proporciona sessionId, intentar obtenerlo del localStorage
    if (!sessionId) {
      sessionId = storage.get('sessionId');
    }

    // Si no hay restaurantId o sessionId, no conectar
    if (!restaurantId || !sessionId) {
      console.warn('No se puede conectar WebSocket: faltan restaurantId o sessionId');
      return;
    }

    // Si ya estamos conectados al mismo restaurante y sesión, no reconectar
    if (
      this.ws &&
      this.ws.readyState === WebSocket.OPEN &&
      this.restaurantId === restaurantId &&
      this.sessionId === sessionId
    ) {
      console.log('WebSocket ya conectado al restaurante:', restaurantId, 'sesión:', sessionId);
      return;
    }

    // Si estamos conectados a un restaurante o sesión diferente, desconectar primero
    if (
      this.ws &&
      (this.restaurantId !== restaurantId || this.sessionId !== sessionId)
    ) {
      console.log(
        'Cambiando conexión de restaurante/sesión:',
        this.restaurantId,
        '/',
        this.sessionId,
        '→',
        restaurantId,
        '/',
        sessionId
      );
      this.shouldReconnect = false;
      this.disconnect();
      this.shouldReconnect = true;
    }

    this.restaurantId = restaurantId;
    this.sessionId = sessionId;
    const url = `${WS_URL}?restaurantId=${restaurantId}&sessionId=${sessionId}&clientType=customer`;

    console.log('Conectando WebSocket a:', url);
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      console.log('WebSocket conectado al restaurante:', restaurantId, 'sesión:', sessionId);
      if (this.reconnectTimeout) {
        clearTimeout(this.reconnectTimeout);
        this.reconnectTimeout = null;
      }
    };

    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('Mensaje recibido:', data);
      this.emit(data.type, data);
    };

    this.ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    this.ws.onclose = () => {
      console.log('WebSocket desconectado');

      // Solo reconectar si shouldReconnect está activado y hay restaurantId y sessionId
      if (this.shouldReconnect && this.restaurantId && this.sessionId) {
        console.log('Reconectando en 5s...');
        this.reconnectTimeout = setTimeout(() => {
          this.connect(this.restaurantId, this.sessionId);
        }, 5000);
      }
    };
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
}

const websocketService = new WebSocketService();
export default websocketService;
